import axiosInstance from "../interceptor/instance";

const baseUrl = `${process.env.REACT_APP_BASE_URL_USER}/template`;

export const addDeleteVersion = async (data) => {
  const response = await axiosInstance.patch(
    `${baseUrl}/module-version`,
    data
  );
  return response.data;
};

export const editUserModules = async (data) => {
  const response = await axiosInstance.post(
    `${baseUrl}/model-by-id`,
    data
  );
  return response.data;
};

export const getModelMatrixData = async () => {
  const response = await axiosInstance.get(
    `${baseUrl}/all-models`
  );
  return response.data;
};

export const getAllTemplates = async (limit, key, order, template, offset) => {
  const response = await axiosInstance.get(
    baseUrl,
    {
      params: {
        limit: limit,
        key: key,
        order: order,
        template: template === "init" || template === "All" ? null : template,
        offset: offset,
      },
    }
  );
  return response.data;
};

export const addTemplate = async (e) => {
  const response = await axiosInstance.post(
    baseUrl,
    e
  );
  return response.data;
};

export const deleteTemplate = async (id) => {
  const response = await axiosInstance.delete(
    `${baseUrl}/${id}`
  );
  return response.data;
};

export const patchTemplate = async (id, data) => {
  const response = await axiosInstance.patch(
    `${baseUrl}/${id}`,
    data
  );
  return response.data;
};

export const getTemplateById = async (id) => {
  const response = await axiosInstance.get(
    `${baseUrl}/${id}`
  );
  return response.data;
};

export const getAllTemplateNames = async () => {
  const response = await axiosInstance.get(
    `${baseUrl}/name`
  );
  return response.data;
};
